import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { DestroyBase } from "../../../../components/common/ng-destroy-base";

/**
 * Handles getting data from argus dialog
 */
@Component({
  selector: 'data-from-argus-dialog',
  templateUrl: './data-from-argus-dialog.component.html',
  styleUrls: ['./data-from-argus-dialog.component.css']
})
export class DataFromArgusDialogComponent extends DestroyBase implements OnInit, OnDestroy {
  /**
   * Is Success or Failure?
   */
  public isSuccessOrFailure = false;

  /**
   * Sets the timeout for the return
   */
  private timeout: ReturnType<typeof setTimeout> = null;

  /**
   * Sets public properties to any
   */
  @Input() public properties: any[];

  /**
 * Can be closed? (as Infobar in table view)
 */
  @Input() public canClose: boolean;

  /**
 * Close pane event
 */
  @Output() public closePane: EventEmitter<any> = new EventEmitter();

  /**
* Should the pane be closed?
*/
  shouldClose = false;

  /**
* Is Succeeded?
*/
  isSuccess = false;

  /**
* Is Failed?
*/
  isFailed = false;

  /**
* Is ConfirmationPopup?
*/
  isConfirmationPopup = false;

  /**
   * New event emitter for continue with argus
   */
  @Output() sholudContinueWithArgus: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * On init
   * */
  ngOnInit(): void {
    this.isConfirmationPopup = true;
  }

  /**
   * On destroy
   * */
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.stopTimer();
  }

  /**
   * Resets the timer
   * */
  private stopTimer(): void {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  /**
   * On continue action
   * */
  public continue() {
    this.isConfirmationPopup = false;
    this.sholudContinueWithArgus.emit(true);
  }

  /**
   * On close dialog action
   * */
  public closeClicked(): void {
    this.shouldClose = true;
    this.stopTimer();
    setTimeout(() => {
      this.closePane.emit();
    }, 500);
  }
}
